/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Facility Internal Request
 * Description: Page for Facility Internal Request
 * Date: 09/06/2022
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import CommonApiService from '../../../services/CommonApiService';
import { useInternalRequest } from './ContextAPI';
import DataTable from './DataTable';
import FormInfo from './FormInfo';
import ShowModel from './ShowModel';

export default function Index() {
    const [drugData, setDrugData] = useState([]);
    const { drugInfo, getDrugInfo } = CommonApiService();

    const { show, setShow, rowData, setRowData } = useInternalRequest();
    const createHander = () => {
        setShow(true);
        setRowData('');
    };
    const backHander = () => {
        setShow(false);
        setRowData('');
    };

    // Drug Info
    const dataList = useCallback(() => {
        getDrugInfo();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    useEffect(() => {
        // DrugInfo
        setDrugData(
            drugInfo?.map((el) => ({
                value: el.drug_id,
                label: el.drug_name,
            }))
        );
    }, [drugInfo]);

    return (
        <>
            <Card>
                <Card.Header className="cardHeader">
                    <h3>Partner Internal Request</h3>
                    {show ? (
                        <div>
                            <Button
                                onClick={() => backHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Back to List
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <Button
                                onClick={() => createHander()}
                                className="btnInfo"
                                variant="primary"
                            >
                                Create New
                            </Button>
                        </div>
                    )}
                </Card.Header>
                <Card.Body>
                    {show ? <FormInfo editData={rowData} drugData={drugData} /> : <DataTable />}
                </Card.Body>
            </Card>
            <ShowModel />
        </>
    );
}
